import 'css-chunk:src/app/containers/Home/ClientsView/ClientDetailView/ClientMemberTags.scss';export default {
  "ClientMemberTags": "_ClientMemberTags_rysk9_1",
  "uploadButton": "_uploadButton_rysk9_1"
};